import { $, owlCarousel } from "./imports";

const featuresCarousel = () => {

    if($('.features-block__list').length > 0){
        let $featuresDCarousel = $('.features-block__list').addClass('owl-carousel').owlCarousel({
            nav: false,
            dots: true,
            navText: [
                '<svg xmlns="http://www.w3.org/2000/svg" width="8.551" height="13.847" viewBox="0 0 8.551 13.847"><path d="M15.514,6l1.627,1.627-5.285,5.3,5.285,5.3-1.627,1.627L8.59,12.923Z" transform="translate(-8.59 -6)" fill="#3c271a"/></svg>',
                '<svg xmlns="http://www.w3.org/2000/svg" width="8.551" height="13.847" viewBox="0 0 8.551 13.847"><path d="M10.217,6,8.59,7.627l5.285,5.3L8.59,18.22l1.627,1.627,6.923-6.923Z" transform="translate(-8.59 -6)" fill="#3c271a"/></svg>'
            ],
            // rewind: true,
            loop: true,
            autoplay: true,
            autoplayTimeout: 8000,
            autoplayHoverPause: true,
            center: true,
            margin: 25,
            responsive: {
                0: {
                    items: 1,
                },
                768: {
                    items: 2,
                },
                992: {
                    nav: true,
                    items: 3,
                },
                1200:{
                    nav: true,
                    items: 3,
                }
            }
        });
    }
}

export default featuresCarousel;